import React from "react";
import { Box, ButtonBase, useTheme } from "@mui/material";
import { MapOutlined, NorthEast, PlaceOutlined } from "@mui/icons-material";
import {
  dashboard2WeekDayActionButtonSx,
  dashboard2WeekDayActionContentSx,
  dashboard2WeekDayActionIconSx,
  dashboard2WeekDayActionLabelSx
} from "../dashboard2-status.styles";
import type { WeekDayCardActionKind } from "../utils/dashboard2-week-day-card.utils";

type Dashboard2WeekDayActionButtonProps = {
  actionKind: WeekDayCardActionKind;
  label: string;
  onClick: () => void;
  "data-testid"?: string;
};

const actionIcon = (kind: WeekDayCardActionKind) => {
  if (kind === "floor_plan") {
    return <MapOutlined sx={{ fontSize: 18 }} />;
  }
  if (kind === "book_place") {
    return <PlaceOutlined sx={{ fontSize: 18 }} />;
  }

  return <NorthEast sx={{ fontSize: 18 }} />;
};

export const Dashboard2WeekDayActionButton: React.FC<Dashboard2WeekDayActionButtonProps> = ({
  actionKind,
  label,
  onClick,
  "data-testid": testId
}) => {
  const theme = useTheme();

  return (
    <ButtonBase
      sx={dashboard2WeekDayActionButtonSx(theme, actionKind)}
      onClick={onClick}
      data-testid={testId}
    >
      <Box sx={dashboard2WeekDayActionContentSx}>
        <Box sx={dashboard2WeekDayActionIconSx}>{actionIcon(actionKind)}</Box>
        <Box component="span" sx={dashboard2WeekDayActionLabelSx}>
          {label}
        </Box>
      </Box>
    </ButtonBase>
  );
};
